export default {
  fonts: {
    main: 'Roboto, sans-serif',
  },
  colors: {
    black01: '#303032',
    black02: '#39393B',
    black03: '#474749',
    white01: '#FCFDFD',
    grey01: '#A3ACB5',
    blue01: '#21D1FA',
    blue02: '#1FB4D7',
    green01: '#69FFCA',
    red01: '#F2505E',
  },
  breakpoints: {
    xs: 'only screen and (max-width: 32rem)',
    s: 'only screen and (max-width: 65rem)',
    m: 'only screen and (max-width: 70rem)',
  },
  spacings: {
    xxs: '.25rem',
    xs: '.5rem',
    s: '1rem',
    m: '2rem',
    l: '3rem',
    xl: '4rem',
    xxl: '6rem',
  },
  animations: {
    link: 'color 0.3s ease',
    button: 'background-color 0.3s ease',
    field: 'border-bottom 0.3s ease',
    filter: 'filter 0.3s ease',
    menu: 'width 0.5s ease',
  },
  shadows: {
    card: 'drop-shadow(0px 8px 8px #2A2A2C)',
  },
};
